module.exports = __webpack_public_path__ + "static/generalUsageNo-89561d082ad0e020cf73e06d9136aed9.png";